import React from 'react'
import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import { toMoney } from '@mobi/utils/money'
import { NoticeBox } from '@core/Components/NoticeBox'
import { formatKambiCurrencyToDollarDecimal } from '@core/Areas/KambiSports/helpers/currencyFormat'
import {
  ReceiptListItemStyled,
  ReceiptListItemTextStyled,
  ReceiptListRowStyled,
  ReceiptListStyled,
  RecieptButtonsContainerStyled,
  RecieptContainerStyled,
} from '../Common/Receipt.styles'
import { ShareButton } from './Components/ShareButton'

export const KambiSportsReceipt: React.FC<{ coupon: Readonly<KambiHistoryCoupon> }> = ({
  coupon,
}) => {
  return (
    <RecieptContainerStyled>
      <NoticeBox noticeBoxType='Success' title='Your bet has been placed.' paddingOverride='0'>
        <ReceiptListStyled>
          <ReceiptListRowStyled>
            <ReceiptListItemStyled>Projected Return</ReceiptListItemStyled>
            <ReceiptListItemTextStyled>
              {toMoney(formatKambiCurrencyToDollarDecimal(coupon.bets[0].potentialPayout))}
            </ReceiptListItemTextStyled>
          </ReceiptListRowStyled>

          <ReceiptListRowStyled>
            <ReceiptListItemStyled>Bet Cost</ReceiptListItemStyled>
            <ReceiptListItemTextStyled>
              {toMoney(formatKambiCurrencyToDollarDecimal(coupon.bets[0].stake))}
            </ReceiptListItemTextStyled>
          </ReceiptListRowStyled>

          <ReceiptListRowStyled>
            <ReceiptListItemStyled>Ticket</ReceiptListItemStyled>
            <ReceiptListItemTextStyled>{coupon.couponRef}</ReceiptListItemTextStyled>
          </ReceiptListRowStyled>
        </ReceiptListStyled>
      </NoticeBox>

      <RecieptButtonsContainerStyled>
        <ShareButton coupon={coupon} />
      </RecieptButtonsContainerStyled>
    </RecieptContainerStyled>
  )
}
